import React from "react";

const Subtitle = ({ value }) => {
  return <h3 className="text-xl mb-4">{value}</h3>;
};

export default Subtitle;
